// Echte Fallbeispiele ("So viel haben unsere Kunden durchgesetzt").
// WICHTIG: Nur echte, vom Inhaber gelieferte Fälle eintragen – niemals erfinden.
// Solange die Liste leer ist, wird der Bereich auf der Website ausgeblendet.
// Format: { schaden: "Auffahrunfall, Golf 8", durchgesetzt: "6.400 € statt 4.100 €", ort: "Köln-Ehrenfeld", text: "…" }
export const FALLBEISPIELE = [];
